import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../services/account.service';
import {Observable} from "rxjs";
import {UserType, User} from "@app/models";
import {NgbdModalSectionTitleContent} from "@screens/activities/forms/modals/section-title.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgbdModalConnectedOrgContent} from "@app/components/layout-menu-left/connected-org.modal";
import {NavbarService} from "@app/services/navbar.service";
import { ExportStatusItem, ExportStatusService } from '@app/services/export-status.service';

@Component({
  selector: 'app-layout-menu-left',
  templateUrl: './layout-menu-left.component.html',
  styleUrls: ['./layout-menu-left.component.sass']
})
export class LayoutMenuLeftComponent implements OnInit {

  public innerWidth: any;
  public sidebarExpanded = true;
  public user: User|null;
  public is_administrator = false;
  public is_merchandising = false;
  public user_organization = false;
  public userType = UserType;

  //Breadcrumb vars
  public TextParent: string = '';
  public LinkParent: string = '';
  public TextActual: string = '';
  exportRequests: ExportStatusItem[] = [];

  hasAccessMarketing: boolean = false;
  hasAccessSales: boolean = false;
  //End Breadcrumb vars
  constructor(
    private accountService: AccountService,
    private modalService : NgbModal,
    private navbarservice: NavbarService,
    private exportStatusService: ExportStatusService,
  ) {
    this.user = accountService.userValue

    this.hasAccessMarketing = this.accountService.has_access('marketing');
    this.hasAccessSales = this.accountService.has_access('sales')

    if (this.user)this.user_organization=this.user.organization
    if(this.user?.user_type == UserType.DoItYourself){
      this.is_administrator = true
    }
    if(this.user?.user_type == UserType.Merchandising){
      this.is_merchandising = true
    }

    this.accountService.user.subscribe(user => {
      this.user = user;
    })

    //Breadcrumb Get Info
    this.navbarservice.TextParentObservable.subscribe(
      value => {
        this.TextParent = value;
        console.log("TextParent", this.TextParent);
      }
    );
    this.navbarservice.LinkParentObservable.subscribe(
      value => {
        this.LinkParent = value;
        console.log("LinkParent", this.LinkParent);
      }
    );
    this.navbarservice.TextActualObservable.subscribe(
      value => {
        this.TextActual = value;
        console.log("TextActual", this.TextActual);
      }
    );
    this.exportStatusService.exportRequests$.subscribe(
      value => {
        this.exportRequests = value;
      }
    );
    //End Breadcrumb Get Info

  }

  ngOnInit(): void {

    if ( this.innerWidth < 1140) {
      this.sidebarExpanded = false;
      console.log("less", this.innerWidth);
    }
    else {
        /* Set the width of the side navigation to 250px and the left margin of the page content to 250px */
        console.log("more", this.innerWidth);
        this.sidebarExpanded = true;
      }

  }

  buttonOpenAndClose(){
    this.sidebarExpanded = !this.sidebarExpanded;
    console.log("cambiando el valor", this.sidebarExpanded);
  }

  logout():void {
    this.accountService.logout()
  }

  openConnectedOrgModal(){
    const modalRef = this.modalService.open(NgbdModalConnectedOrgContent);
    // modalRef.componentInstance.form_section = section;

  }

  cancelConnectOrg(){
    this.accountService.connectToOrganization(null);
    window.location.reload();
  }

  dismissExportRequest(exportId: number) {
    this.exportStatusService.dismiss(exportId);
  }
}
